import { render, staticRenderFns } from "./settings-company-offices.vue?vue&type=template&id=e7b56f54&"
import script from "./settings-company-offices.ts?vue&type=script&lang=ts&"
export * from "./settings-company-offices.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports